import React from "react";
import "./style/home.css";


export default function Home() {
  return (
    <>
      <div className="home-container">
        <div className="image-container">
          <img src="/welcome_instructions.png" alt="homeImage" style={{ width: '443px', height: '425px' }} />
        </div>
        <div className="instructions-container">
          <div className="instructions-header">
            <img src="/visenze_logo.png" alt="visenzeLogo" style={{ width: '80px', height: '16px' }} />
            <div className="header-text">
              Thank you for installing ViSenze!<br />
              Launch the extension to get started.
            </div>
          </div>
          <div className="instructions-detail">
            <div className="detail">
              <div className="counter">1</div>
              <div className="explanation">In the side panel, look for the Sales Channel you wish to use ViSenze in.</div>
            </div>
            <div className="detail">
              <div className="counter">2</div>
              <div className="explanation">Select “Extensions”</div>
            </div>
            <div className="detail">
              <div className="counter">3</div>
              <div className="explanation">Launch ViSenze’s extension</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
